import React, { useState, useContext, useEffect } from 'react'
import styles from '../css/share/share-modal.module.css';
import StorySelection from '../weekReflection/StorySelection';
import ShareMessage from './ShareMessage';
import ShareLink from './ShareLink';
import { ShareLinkContext } from './ShareLinkContext';

function ShareModal({ shareUrl, timeOfDay, bgColor }) {
    const { showShareModal, setShowShareModal, setSelectionMode, storySelection } = useContext(ShareLinkContext);
    const [currentScreen, setCurrentScreen] = useState(0);

    const closeModal = () => {
        setShowShareModal(false)
    }

    const onNext = () => {
        if (currentScreen < components.length - 1) {
            setCurrentScreen(currentScreen + 1);
        }
        else {
            closeModal();
        }
    }

    useEffect(() => {
        if (shareUrl.includes('story')) {
            setSelectionMode(true);
        }
    }, [shareUrl])

    let components = [
        {
            componentName: 'shareLink',
            component: <ShareLink key='shareLink' shareUrl={shareUrl} closeModal={closeModal} />
        }
    ];
    if (shareUrl.includes('story')) {
        components.unshift(
            {
                componentName: 'storySelection',
                component: <StorySelection key='storySelection' bgColor={bgColor} onNext={onNext} />
            },
            {
                componentName: 'shareMessage',
                component: <ShareMessage key='shareMessage' shareType={storySelection ? 'story' : 'week'} timeOfDay={timeOfDay} onNext={onNext} />
            }
        )
    }

    return (
        showShareModal &&
        <div className={styles.modalContainer} onClick={closeModal}>
            <div className={`${styles.modalBase} ${styles.modalCentered}`} onClick={(e) => e.stopPropagation()}>
                {components[currentScreen].component}
            </div>
        </div>
    )
}

export default ShareModal